import { Form, Input, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import MUploadImage from "../../../../component/UploadImage";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { FileResponse } from "../../customer/entity/customer.model";
import { fileService } from "../../shared/service/file.service";
import {
  CommentCategory,
  MComment,
  Product,
  ProductUI,
} from "../entity/product.model";
import { productService } from "../service/product.service";
import LabDocument from "./component/LabDocument";
import CComment from "./component/CComment";
import CComments from "./component/CComments";
import Authorization from "../../../../component/Authorization";

function EditProduct() {
  const { Option } = Select;
  const { dispatch } = useContext(SpinContext);
  let { productId } = useParams();
  let navigate = useNavigate();
  const [product, setProduct] = useState<ProductUI>();

  useEffect(() => {
    if (productId) {
      dispatch({ type: spinActions.BLOCK });
      productService
        .getProduct(productId)
        .then((_product: Product) => {
          helper.getImage(_product.imagePath).then((file) => {
            setProduct({
              ..._product,
              image: file,
            });
          });

          dispatch({ type: spinActions.UNBLOCK });
        })
        .catch(() => {
          dispatch({ type: spinActions.UNBLOCK });
        });
    }

    return () => {
      setProduct(undefined);
    };
  }, [productId]);

  const editProduct = (_product: Product) => {
    productService.editProduct(_product).then(() => {
      dialog.success("Бүтээгдэхүүн амжилттай шинэчлэгдлээ.");
      navigate("/products");
    });
  };

  const onFinish = (values: ProductUI) => {
    if (product) {
      let _product: Product = {
        ...product,
      };

      if (values.image && values.image.name !== product.image?.name) {
        fileService
          .uploadFile(values.image)
          .then((fileReponse: FileResponse) => {
            _product.imagePath = fileReponse.fileName;
            editProduct(_product);
          });
      } else {
        editProduct(_product);
      }
    }
  };

  return (
    <>
      <MPageHeader crumbs={["Бүтээгдэхүүнүүд", product?.name ?? ""]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h5 className="card-title">Бүтээгдэхүүний мэдээлэл</h5>
          </div>
          <div className="card-body">
            {product && (
              <fieldset disabled={!helper.hasRoles(["product-full"])}>
                <Form initialValues={product} onFinish={onFinish}>
                  <div className="form-group">
                    <label>
                      Бүтээгдэхүүний зураг<span className="text-danger">*</span>
                    </label>

                    <Form.Item
                      name="image"
                      rules={[
                        {
                          required: true,
                          message: "Бүтээгдэхүүний зургыг оруулна уу.",
                        },
                      ]}
                    >
                      <MUploadImage
                        disabled={!helper.hasRoles(["product-full"])}
                      />
                    </Form.Item>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Код</label>
                        <Form.Item name="uuid">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Бүтээгдэхүүний код</label>
                        <Form.Item name="article">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Барааны ажлын нэр</label>
                        <Form.Item name="name">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Үйлдвэрлэгч улс</label>
                        <Form.Item name="country">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Брэнд</label>
                        <Form.Item>
                          <Input
                            value={product.brand.name}
                            readOnly={true}
                            className="form-control"
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Ангилал</label>
                        <Form.Item>
                          <Input
                            value={product.category.name}
                            readOnly={true}
                            className="form-control"
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Хэрэглэх заавар</label>
                    <Form.Item name="description">
                      <Input.TextArea
                        readOnly
                        rows={5}
                        className="form-control"
                      />
                    </Form.Item>
                  </div>
                  <hr />
                  <CComments productId={productId!} />
                  <hr />
                  <div className="form-group">
                    <label>
                      Шинжилгээний бичиг<span className="text-danger">*</span>
                    </label>
                    <Form.Item name="documents">
                      <LabDocument
                        product={product}
                        disabled={!helper.hasRoles(["product-full"])}
                      />
                    </Form.Item>
                  </div>

                  <Authorization roles={["product-full"]}>
                    <div className="text-right">
                      <button type="submit" className="btn btn-primary">
                        Хадгалах <i className="icon-floppy-disk ml-2" />
                      </button>
                    </div>
                  </Authorization>
                </Form>
              </fieldset>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EditProduct;
